<ng-container *ngIf="!nextEvent && isLoaded">
  <div class="nonext nextclass-content">
    <div class="dashboard-spacetitle">
      <span translate>teacher.dashboard-teacher.noLessonsPlanned</span>
    </div>
    <div class="dashboard-maininfo">
      <span translate>teacher.dashboard-teacher.next-session-explaination</span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="nextEvent && isLoaded">
  <div class="nextclass-content">
    <div class="dashboard-spacetitle">
      <span *ngIf="nextEvent.instance === 'occurrence'" translate>teacher.dashboard-teacher.next-class-label </span>
      <!-- TODO a traduire -->
      <span *ngIf="nextEvent.instance === 'lilate'" translate>teacher.dashboard-teacher.upNextLilate</span>
      <span [ngSwitch]="countdownStatus">
        <span *ngSwitchCase="'from'" translate>teacher.dashboard-teacher.from-label</span>
        <span *ngSwitchCase="'outdated'" translate>teacher.dashboard-teacher.outdated-since-label</span>
        <span *ngSwitchCase="'finish'" translate>teacher.dashboard-teacher.finish-since-label</span>
        <span *ngSwitchDefault translate>teacher.dashboard-teacher.in-label</span>
        {{countdown}}
      </span>
    </div>

    <!-- student -->
    <div class="dashboard-maininfo">
      <div class="training-suspended" *ngIf="nextEvent.formation_status=='suspended'" translate>
        teacher.dashboard-teacher.suspended</div>
      <div class="training-suspended" *ngIf="nextEvent.formation_status=='suspended'">Suspended</div>
      <div class="nextclass-time">
        {{nextEvent.start | amLocale: 'en' | amDateFormat:'ddd DD MMM'}},
        {{nextEvent.start | amLocale: 'en' | amDateFormat:'HH:mm'}} - {{nextEvent.end | amLocale: 'en' |
        amDateFormat:'HH:mm'}}
      </div>
      <div class="nextclass-studname"><span translate>teacher.dashboard-teacher.with-label</span> {{student.user.first_name}}
        {{student.user.last_name}}</div>
      <div class="nextclass-studname" *ngIf="nextEvent.targeted_level" translate>
        teacher.dashboard-teacher.targetLevel
        <span>{{nextEvent.targeted_level}}</span>
      </div>
      <div class="tag-specific-content" *ngIf="formation && formation.specific_content">
        <span *ngFor='let sp of formation.specific_content'>
          <span *ngIf="sp.name!='default'">{{ sp.name }}</span>
        </span>
      </div>
    </div>

    <div class="nextclass-skypeid" *ngIf="student.user.video_provider=='skype'"><span>{{student.user.id_skype}}</span>
    </div>

    <div class="seetraining-btn" *ngIf="nextEvent && nextEvent.formation_id"
      routerLink="/trainings/detail/{{nextEvent.formation_id}}/info">
      <span translate>teacher.dashboard-teacher.see-training</span>
    </div>
    <div>
      <button *ngIf="nextEvent.provider_link" (click)="joinClass()" class="teamscall-btn" [disabled]="!linkIsValid()">
        <span>{{ nextEvent.instance === 'lilate' ? 'Join Exam Room' : 'Join class'}}</span>
      </button>

      <button *ngIf="nextEvent.instance === 'lilate' && linkIsValid()" class="open-assessment-btn"
        (click)="openAssessment()">
        <span translate>teacher.dashboard-teacher.openAssessmentSheet</span>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf='!isLoaded'>
  <div class="row center loading pageload-message">
    <span translate>teacher.dashboard-teacher.next-occurrence-loading</span>
  </div>
</ng-container>